import envs from "../envs";

export const seguroVida = `${envs.hostCaixaVidaPrevidencia}/segurodevida`;
export const seguroPrestamista = `${envs.hostCaixaVidaPrevidencia}/seguroprestamista`;
export const seguroAutoAntigo = `/paravoce/auto`;
export const seguroAutoNovo = `/paravoce/auto/Paginas/novo-seguro-auto.aspx`;
export const consorciosNovo = `${envs.hostCaixaConsorcio}/consorcios`;
export const previdencia = `${envs.hostCaixaVidaPrevidencia}/previdencia`;
export const seguroSaude = `/paravoce/seguro-saude`;
export const odontologico = `/paravoce/odontologico`;
